import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { WiggleBone } from "../wiggle";
// import { WiggleBone } from "../wiggle/WiggleSpring";

// Setup renderer
const canvas = document.querySelector("canvas.webgl");
const renderer = new THREE.WebGLRenderer({ canvas: canvas });
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setClearColor(0x4987A1);
document.body.appendChild(renderer.domElement);

// Setup scene
const scene = new THREE.Scene();

// Setup camera
const camera = new THREE.PerspectiveCamera(
  75,
  window.innerWidth / window.innerHeight,
  0.1,
  100
);
camera.position.set(0, 0, 10);

// Setup orbit controls
const controls = new OrbitControls(camera, renderer.domElement);

// Setup lights
const ambientLight = new THREE.AmbientLight(0xffffff, .5);
const directionalLight = new THREE.DirectionalLight(0xffffff, .8);
scene.add(ambientLight, directionalLight);

const wiggleBones = [];
let rootBone;

// document.addEventListener('mousedown', () => {
//   rootBone.scale.set(1.5, 1.5, 1.5);
// });

// document.addEventListener('mouseup', () => {
//   rootBone.scale.set(1, 1, 1);
// });


// Load GLTF model
const loader = new GLTFLoader();
loader.load(
  "/orca.glb",
  (glb) => {
    const mesh = glb.scene.getObjectByName("orca");
    mesh.position.z = -1;
    mesh.position.y = -1;

    // add orca_texture.jpg to the mesh
    const textureLoader = new THREE.TextureLoader();
    const texture = textureLoader.load("/orca_texture.jpg");
    texture.flipY = false;
    mesh.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.material.map = texture;
        // make it fairly shiny
        child.material.shininess = 100;
        child.material.specular = new THREE.Color(0x111111);
        child.material.needsUpdate = true;
      }
    });
    console.log(mesh);
    if (mesh) {
      scene.add(mesh);

      mesh.skeleton.bones.forEach((bone) => {
        if (!bone.parent.isBone) {
          rootBone = bone;
        } else {
          wiggleBones.push(new WiggleBone(bone, { velocity: 0.2}));
        }
      });
    }
  },
  undefined,
  (error) => {
    console.error("An error happened", error);
  }
);

// make the rootbone move up and down with the mouse cursor
document.addEventListener("mousemove", (event) => {
  if (rootBone) {
    rootBone.position.x = ((event.clientX / window.innerWidth) * 3 - 1.5) * 5;
    rootBone.position.y = ((event.clientY / window.innerHeight) * -3 + 1.5) * 5;
  }
});

// when key press 'x' toggle wireframe
document.addEventListener("keydown", (event) => {
  if (event.key === "x") {
    scene.traverse((child) => {
      if (child instanceof THREE.Mesh) {
        child.material.wireframe = !child.material.wireframe;
      }
    });
  }
});

// Modify the animation loop to include updateBone, raycasting for hover and drag detection
function animate() {
  requestAnimationFrame(animate);

  if (rootBone) {
    // make an aggresive sin wave with long pauses between peaks
    // rootBone.rotation.x += 0.01;
    // rootBone.rotation.y = Math.sin(Date.now() * 0.001) * 1;
    rootBone.position.y = Math.sin(Date.now() * 0.006) * 2 - 2;

    wiggleBones.forEach((wiggleBone) => wiggleBone.update());
  }
  // controls.update();
  renderer.render(scene, camera);
}

animate();
